import { render, staticRenderFns } from "./CompletedCounter.vue?vue&type=template&id=2cf78e2b&scoped=true&"
import script from "./CompletedCounter.vue?vue&type=script&lang=ts&"
export * from "./CompletedCounter.vue?vue&type=script&lang=ts&"
import style0 from "./CompletedCounter.vue?vue&type=style&index=0&id=2cf78e2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf78e2b",
  null
  
)

export default component.exports